import { delete_request, get, patch, post } from '@/tools/http';
import moment from 'moment';
import { NOGENDER } from '@/consts/gender';
import str_counter from '@/tools/str_counter';
import { parseISO, differenceInYears } from 'date-fns';

const isMock = false;

function pseudoApi(data, errorStatus) {
    return new Promise((response, reject) => {
        setTimeout(() => {
            if (!errorStatus) {
                response(data);
            } else {
                reject({ message: 'error', status: errorStatus });
            }
        });
    });
}

function arrayToObject(array = [], key = 'id') {
    return array.reduce((res, curr) => {
        res[curr[key]] = curr;
        return res;
    }, {});
}

const userMock = {
    users: [
        {
            id: 5,
            userId: 123,
            avatar: {
                url: null,
            },
            name: 'Алексей',
            age: 23,
            dateOfBirth: '1999-01-19T00:00:00+00:00',
            gender: true,
            address: { value: 'г. Петропавловск-Камчатский' },
            activity: ['Информационные технологии, телекоммуникации, связь'],
            about: 'г. Петропавловск-Камчатский',
            vk: 'https://userProfileInfo.vk',
            ok: 'https://userProfileInfo.ok',
            ig: 'https://userProfileInfo.instagram',
            fb: 'https://userProfileInfo.fb',
            yt: 'https://userProfileInfo.yt',
            tel: '+7 (980) 345-20-34',
            regEmail: 'asdf@mail.ru',
            status: 'предприниматель',
            foreignStatusId: 962,
            organization: 'Mail.Ru Group',
            position: 'UX/UI дизайнер',
            instituteAddress: 'Москва',
            activityPeriod: 'январь 2019 г. — декабрь 2020 г.',
            instituteSite: 'corp.mail.ru',
            responsibilities: 'сложные и много',
            volunteer: 'Adventure projects',
            socialWorks: 'сложная социальная работа с различными группами населения',
            projectHistories: [],
            desiredArea: ['IT сфера'],
            isNoWorkExperience: false,
            userEducation: [
                {
                    id: 'e1',
                    foreignLevelId: 943,
                    educationPlace: 'Школа',
                    foreignPlaceId: null,
                    city: { value: 'г. Томск' },
                    dateStart: '1982-02-01T00:00:00+00:00',
                    dateEnd: '1993-07-01T00:00:00+00:00',
                    isNow: false,
                    foreignSpecialtyId: null,
                    qualification: null,
                    foreignDegreeId: null,
                    schoolClass: '11',
                },
                {
                    id: 'e2',
                    foreignLevelId: 945,
                    educationPlace: null,
                    foreignPlaceId: 26441,
                    city: { value: 'г. Томск' },
                    dateStart: '2016-02-01T00:00:00+00:00',
                    dateEnd: null,
                    isNow: true,
                    foreignSpecialtyId: 25132,
                    qualification: 'Бакалавр',
                    foreignDegreeId: 957,
                    schoolClass: null,
                },
            ],
            userCareers: [
                {
                    id: 'c1',
                    organization: 'ООО ААА',
                    position: 'Помощник управляющего',
                    region: { value: 'г. Томск' },
                    dateStart: '2019-05-01T00:00:00+00:00',
                    dateEnd: '2019-11-01T00:00:00+00:00',
                    isUntilNow: false,
                    website: 'http://oooaaa.com',
                    responsibilities: 'помогать управляющему',
                },
                {
                    id: 'c2',
                    organization: 'cybertech',
                    position: 'developer',
                    region: { value: 'г. Томск' },
                    dateStart: '2019-11-01T00:00:00+00:00',
                    dateEnd: null,
                    isUntilNow: true,
                    website: 'https://cybertech.com',
                    responsibilities: 'Разароботка',
                },
            ],
        },
    ],
};

const searchingUsersMock = {
    users: [
        {
            id: 5,
            avatar: {
                url: null,
            },
            name: 'Алексей',
            userId: 123,
            projectHistories: [],
        },
        {
            id: 15,
            avatar: {
                url: null,
            },
            name: 'Борис',
            userId: 223,
            projectHistories: [],
        },
        {
            id: 52,
            avatar: {
                url: null,
            },
            name: 'Геннадий',
            userId: 133,
            projectHistories: [],
        },
    ],
    page: 2,
    pages: 4,
};

const filtersMock = {
    filters: [
        {
            id: 1,
            name: 'projects',
            isHidden: false,
        },
        {
            id: 2,
            name: 'gender',
            isHidden: false,
        },
        {
            id: 3,
            name: 'birthFrom',
            isHidden: false,
        },
        {
            id: 4,
            name: 'birthTo',
            isHidden: false,
        },
        {
            id: 5,
            name: 'city',
            isHidden: false,
        },
        {
            id: 6,
            name: 'status',
            isHidden: false,
        },
        {
            id: 7,
            name: 'activity',
            isHidden: false,
        },
        {
            id: 8,
            name: 'educationLevel',
            isHidden: false,
        },
        {
            id: 9,
            name: 'educationPlace',
            isHidden: false,
        },
        {
            id: 10,
            name: 'specialization',
            isHidden: false,
        },
        {
            id: 11,
            name: 'professions',
            isHidden: false,
        },
        {
            id: 12,
            name: 'competences',
            isHidden: false,
        },
        {
            id: 13,
            name: 'skills',
            isHidden: false,
        },
    ],
};

const awardsMock = {
    items: [],
};

const projectsMock = [
    {
        id: 54,
        name: 'Профстажировки 2.0',
        dateStart: '2021-02-08T09:51:23.388Z',
        dateEnd: '2021-02-08T09:51:23.388Z',
        status: 'Участник',
        logo: {
            url: null,
        },
    },
    {
        id: 157,
        name: "Проект 'Хочу участвовать'",
        dateStart: '2021-02-08T09:51:23.388Z',
        dateEnd: '2021-02-08T09:51:23.388Z',
        status: 'Полуфиналист',
        logo: {
            url: null,
        },
    },
];

const competencesMock = {
    items: [
        {
            id: 33,
            name: 'Быстродействие',
            type: 'soft',
        },
        {
            id: 35,
            name: 'Многозадачность',
            type: 'soft',
        },
        {
            id: 101,
            name: 'Психология',
            type: 'hard',
        },
    ],
};

const profilesMock = {
    items: [
        {
            id: 436,
            name: 'Инженер',
            entityType: 'profession',
        },
        {
            id: 22,
            name: 'super главный официант',
            entityType: 'profession',
        },
    ],
};

const friendsMock = {
    users: [
        {
            id: 0,
            name: 'string',
            surname: 'string',
            patronymic: 'string',
            avatar: 'string',
        },
        {
            id: 1,
            name: 'string',
            surname: 'string',
            patronymic: 'string',
            avatar: 'string',
        },
    ],
};

const hiddenFieldsProjectsMock = {
    fields: ['nomination'],
};

const hiddenFieldsProgressMock = {
    fields: ['competence', 'profile'],
};

const chatIsPrivateMock = {
    isPrivate: true,
};

export default {
    namespaced: true,

    state: () => ({
        user: {
            userId: null,
        },
        searchingUsers: {},
        searchingUsersPages: 0,
        filters: [],
        userAchievements: [],
        userAwards: [],
        userProjects: [],
        userProjectsSPK: [],
        userInternShipsSPK: [],
        userVacanciesSPK: [],
        userEvents: [],
        userCourses: [],
        userCompetences: [],
        userProfessions: [],
        userFriends: [],
        userFriendsTotal: null,
        userIsAFriend: null,
        userHiddenFieldsProjects: [],
        userHiddenFieldsProgress: [],
        userChatIsPrivate: false,
        chatWithUserIsPrivate: true,
        cities: [],
        searchFilters: [],
        userSearchLoading: false,
        userCareers: [],
        userEducations: [],
        userComments: [],
        loaded: {
            user: false,
            userProjects: false,
            userCourses: false,
            userAchievements: false,
            userEducations: false,
            userCareers: false,
            userCompetences: false,
        },
    }),

    mutations: {
        setSearchingUsers(state, users) {
            state.searchingUsers = users;
        },

        setSearchingUsersPages(state, count) {
            state.searchingUsersPages = count;
        },

        setUser(state, user) {
            state.user = user;
            state.loaded = { ...state.loaded, user: true };
        },

        setUserAchievements(state, achievements) {
            state.userAchievements = achievements;
            state.loaded = { ...state.loaded, userAchievements: true };
        },

        setUserAwards(state, awards) {
            state.userAwards = awards;
        },

        setUserProjects(state, projects) {
            state.userProjects = projects;
        },

        setUserProjectsSPK(state, projects) {
            state.userProjectsSPK = projects;
        },

        setUserInternShipsSPK(state, internShips) {
            state.userInternShipsSPK = internShips;
        },

        setUserVacanciesSPK(state, vacancies) {
            state.userVacanciesSPK = vacancies;
        },

        setUserEvents(state, events) {
            state.userEvents = events;
            state.loaded = { ...state.loaded, userEvents: true };
        },

        setUserCourses(state, courses) {
            state.userCourses = courses;
            state.loaded = { ...state.loaded, userCourses: true };
        },

        setUserCompetences(state, competences) {
            state.userCompetences = competences;
            state.loaded = { ...state.loaded, userCompetences: true };
        },

        setUserProfessions(state, professions) {
            state.userProfessions = professions;
        },

        setUserFriends(state, friends) {
            state.userFriends = friends;
        },

        setUserFriendsTotal(state, friendsTotal) {
            state.userFriendsTotal = friendsTotal;
        },

        setFilters(state, filters) {
            state.filters = filters;
        },

        setUserAsAFriend(state, flag) {
            state.userIsAFriend = flag;
        },

        setUserHiddenFieldsProjects(state, fields) {
            state.userHiddenFieldsProjects = fields;
        },

        setUserHiddenFieldsProgress(state, fields) {
            state.userHiddenFieldsProgress = fields;
        },

        setUserChatIsPrivate(state, userChatIsPrivate) {
            state.userChatIsPrivate = userChatIsPrivate;
        },

        setChatWithUserIsPrivate(state, flag) {
            state.chatWithUserIsPrivate = flag;
        },

        setCities(state, cities) {
            state.cities = cities;
        },

        setSearchFilters(state, searchFilters) {
            state.searchFilters = searchFilters;
        },

        setUserSearchLoading(state, flag) {
            state.userSearchLoading = flag;
        },

        setUserCareers(state, data) {
            state.userCareers = data;
            state.loaded = { ...state.loaded, userCareers: true };
        },

        setUserEducations(state, data) {
            state.userEducations = data;
            state.loaded = { ...state.loaded, userEducations: true };
        },

        setUserComments(state, data) {
            state.userComments = data;
        },

        setLoaded(state, data) {
            state.loaded = data;
        },
    },

    actions: {
        fullResetUserStore({ commit }) {
            commit('setSearchingUsers', {});
            commit('setSearchingUsersPages', 0);
            commit('setUser', null);
            commit('setUserAwards', []);
            commit('setUserProjects', []);
            commit('setUserProjectsSPK', []);
            commit('setUserEvents', []);
            commit('setUserCourses', []);
            commit('setUserCompetences', []);
            commit('setUserProfessions', []);
            commit('setUserFriends', []);
            commit('setUserFriendsTotal', null);
            commit('setFilters', []);
            commit('setUserAsAFriend', null);
            commit('setUserHiddenFieldsProjects', []);
            commit('setUserHiddenFieldsProgress', []);
            commit('setUserChatIsPrivate', false);
            commit('setChatWithUserIsPrivate', true);
            commit('setCities', []);
            commit('setSearchFilters', []);
            commit('setUserSearchLoading', false);
            commit('setUserCareers', []);
            commit('setUserEducations', []);
            commit('setUserComments', []);
            commit('setLoaded', {
                user: false,
                userProjects: false,
                userAchievements: false,
                userEducations: false,
                userCareers: false,
                userCompetences: false,
                userCourses: false,
            });
        },

        async loadSearchingUsers({ commit }, { fields = [], filters = [], params = { limit: 6, offset: 0 } }) {
            let birthFrom = filters.find((el) => el.name === 'birthFrom');
            let birthTo = filters.find((el) => el.name === 'birthTo');
            filters = filters
                .map((el) => {
                    const falsyValues = ['', NOGENDER];
                    if (falsyValues.includes(el.value) || (Array.isArray(el.value) && el.value.length === 0)) {
                        return;
                    }
                    if (birthFrom && birthTo && birthFrom.value === birthTo.value && el.name === 'birthFrom') {
                        el.value = moment(el.value).subtract(1, 'years').format('YYYY-MM-DD');
                    }
                    if (el.name === 'city' && el.value && el.value.data) {
                        el.value = el.value.data.city;
                    }
                    return el;
                })
                .filter((el) => el);

            const data = {
                fields,
                filters,
            };
            let users = [];
            let count = 0;
            try {
                const answer = isMock
                    ? await pseudoApi(searchingUsersMock)
                    : await post('profile', `users/search?limit=${params.limit}&offset=${params.offset}`, data, true);
                if (answer) {
                    users = answer.users;
                    count = answer.pages;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setSearchingUsers', arrayToObject(users));
                commit('setSearchingUsersPages', count);
            }
        },

        clearSearchingUsers({ commit }) {
            commit('setSearchingUsers', {});
            commit('setSearchingUsersPages', 0);
        },

        async loadUserById({ commit }, { userId, fields = [] }) {
            const data = {
                fields,
                filters: [{ name: 'userId', value: userId }],
            };
            let user = null;
            try {
                const answer = isMock
                    ? await pseudoApi(userMock)
                    : await post('profile', 'users/filter?only_ids=1', data, true);
                if (answer) {
                    user = answer.users[0] || null;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUser', user);
            }
        },

        async loadActivityTimeUserById({ commit }, userId) {
            try {
                const answer = await get('identity', `api/v1/statistics/lastactivity/user/${userId}`, {}, true);
                return answer.last_activity_at;
            } catch (e) {
                console.log(e);
            }
        },

        async loadFullUserById({ commit }, userId) {
            let user = null;

            try {
                if (isMock) {
                    user = (await pseudoApi(userMock)).users[0];
                } else {
                    const answer = await get('profile', `user/${userId}`, { only_ids: 1 }, true);
                    user = answer && answer.data && answer.data.info ? answer.data.info : null;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUser', user);
            }
        },

        async downloadDocx({ state, rootGetters, getters }) {
            const data = getters.getDownloadData;
            return await post('profile', 'export/portfolio/docx', data, true, {}, true, true, 'blob');
        },

        async downloadPdf({ state, rootGetters, getters }) {
            const data = getters.getDownloadData;
            return await post('profile', 'export/portfolio/pdf', data, true, {}, true, true, 'blob');
        },

        async loadFilters({ commit }) {
            let filters = [];
            try {
                const answer = isMock ? await pseudoApi(filtersMock) : await get('profile', 'searchFilter/all');
                if (answer) {
                    filters = answer.filters;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setFilters', arrayToObject(filters, 'name'));
            }
        },

        async loadUserAwards({ commit }, userId) {
            let awards = [];
            try {
                const answer = isMock ? await pseudoApi(awardsMock) : await get('profile', ``);
                if (answer) {
                    awards = answer.items;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserAwards', awards);
            }
        },

        async loadUserProjects({ commit }, userId) {
            let projects = [];
            try {
                const answer = isMock
                    ? await pseudoApi(projectsMock)
                    : await get(
                          'projects',
                          `api/v1/seasons/nomination/get-user-nominations/${userId}`,
                          {},
                          false,
                          false
                      );
                if (answer) {
                    projects = answer;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserProjects', projects);
            }
        },

        async loadUserProjectsSPK({ commit }, { userId, filters, fetchOnly = false }) {
            let projects = [];
            const query = [];

            if (filters.types) {
                filters.types.forEach((type) => {
                    query.push(`filter[types]=${type}`);
                });
            }

            try {
                const answer = await get(
                    'projects2',
                    `api/v1/project/user/${userId}?${query.join('&')}`,
                    {},
                    true,
                    false
                );
                projects = answer ? answer.data || [] : [];
            } catch (e) {
                console.log(e);
            } finally {
                if (!fetchOnly) {
                    commit('setUserProjectsSPK', projects);
                }
            }

            return projects;
        },

        async loadUserInternShips({ commit }, { userId, filters }) {
            let internShips = [];
            const query = [];

            if (filters.types) {
                filters.types.forEach((type) => {
                    query.push(`filter[types]=${type}`);
                });
            }

            try {
                const answer = await get(
                    'projects2',
                    `api/v1/project/user/${userId}?${query.join('&')}`,
                    {},
                    true,
                    false
                );
                internShips = answer ? answer.data || [] : [];
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserInternShipsSPK', internShips);
            }

            return internShips;
        },

        async loadUserVacancies({ commit }, { userId, filters }) {
            let vacancies = [];
            const query = [];

            if (filters.types) {
                filters.types.forEach((type) => {
                    query.push(`filter[types]=${type}`);
                });
            }

            try {
                const answer = await get(
                    'projects2',
                    `api/v1/project/user/${userId}?${query.join('&')}`,
                    {},
                    true,
                    false
                );
                vacancies = answer ? answer.data || [] : [];
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserVacanciesSPK', vacancies);
            }

            return vacancies;
        },

        async loadUserCompetences({ commit }, userId) {
            let competences = [];
            try {
                const answer = isMock
                    ? await pseudoApi(competencesMock)
                    : await get('progress', `api/v2/user/${userId}/competences`, {}, false, false);
                if (answer) {
                    competences = answer.items;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserCompetences', competences);
            }
        },

        async loadUserProfessions({ commit }, userId) {
            let professions = [];
            try {
                const answer = isMock
                    ? await pseudoApi(profilesMock)
                    : await get('progress', `api/v2/user/${userId}/profiles`, {}, false, false);
                if (answer) {
                    professions = answer.items;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserProfessions', professions);
            }
        },

        async loadUserFriends({ commit }, { params = { limit: 6, offset: 0 } }) {
            let friends = [];
            let friendsTotal = null;
            try {
                const answer = isMock
                    ? await pseudoApi(friendsMock)
                    : await get('profile', `friends?limit=${params.limit}&offset=${params.offset}`, {}, false, false);
                if (answer) {
                    friends = answer.users;
                    friendsTotal = answer.total;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserFriends', friends);
                commit('setUserFriendsTotal', friendsTotal);
            }
        },

        async addFriend({ commit }, userId) {
            let flag = false;
            try {
                await post('profile', `friend/${userId}`, null, true);
                flag = true;
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserAsAFriend', flag);
            }
        },

        async removeFriend({ commit }, userId) {
            let flag = true;
            try {
                await delete_request('profile', `friend/${userId}`, null, true);
                flag = false;
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserAsAFriend', flag);
            }
        },

        async checkFriend({ commit }, { userId, store }) {
            let isAFriend = false;
            try {
                const answer = await get('profile', `friend/${userId}/check`, {}, false, false);
                isAFriend = answer.isFriend;
            } catch (e) {
                console.log(e);
            } finally {
                if (store) {
                    commit('setUserAsAFriend', isAFriend);
                }
            }
            return isAFriend;
        },

        async addUserHiddenFieldsProfile({ commit }, { userId, hiddenFields }) {
            const data = {
                userId: userId,
                hiddenFields: hiddenFields,
            };
            try {
                await post('profile', 'user/hiddenFields/add', data, true, {}, true);
            } catch (e) {
                console.log(e);
            }
        },

        async removeUserHiddenFieldsProfile({ commit }, { userId, hiddenFields }) {
            const data = {
                userId: userId,
                hiddenFields: hiddenFields,
            };
            try {
                await post('profile', 'user/hiddenFields/remove', data, true, {}, true);
            } catch (e) {
                console.log(e);
            }
        },

        async loadUserHiddenFieldsProjects({ commit }) {
            let hiddenFieldsProjects = [];
            try {
                const answer = isMock
                    ? await pseudoApi(hiddenFieldsProjectsMock)
                    : await get('projects', 'user/hiddenFields');
                if (answer) {
                    hiddenFieldsProjects = answer.fields;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserHiddenFieldsProjects', hiddenFieldsProjects);
            }
        },

        async changeUserHiddenFieldProjects({ commit }, data) {
            try {
                await patch('projects', 'user/hiddenFields', data, true, {}, true);
            } catch (e) {
                console.log(e);
            }
        },

        async loadUserHiddenFieldsProgress({ commit }) {
            let hiddenFieldsProgress = [];
            try {
                const answer = isMock
                    ? await pseudoApi(hiddenFieldsProgressMock)
                    : await get('progress', 'api/v2/user/hiddenFields', {}, false, false);
                if (answer) {
                    hiddenFieldsProgress = answer.fields;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserHiddenFieldsProgress', hiddenFieldsProgress);
            }
        },

        async changeUserHiddenFieldProgress({ commit }, data) {
            try {
                await patch('progress', 'api/v2/user/hiddenFields', data, true, {}, true);
            } catch (e) {
                console.log(e);
            }
        },

        async loadUserChatIsPrivate({ commit }) {
            let userChatIsPrivate = false;
            try {
                const answer = isMock ? await pseudoApi(chatIsPrivateMock) : await get('chat', 'settings');
                if (answer) {
                    userChatIsPrivate = answer.isPrivate;
                }
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserChatIsPrivate', userChatIsPrivate);
            }
        },

        async changeUserChatIsPrivate({ commit }, data) {
            try {
                patch('chat', 'settings', data, true, {}, true);
            } catch (e) {
                console.log(e);
            }
        },

        async loadChatWithUserIsPrivate({ commit }, { userId, store = true }) {
            let flag = true;
            try {
                const answer = await get('chat', `user/${userId}/isPrivate`);
                if (answer) {
                    flag = answer.isPrivate;
                }
            } catch (e) {
                console.log(e);
            } finally {
                if (store) {
                    commit('setChatWithUserIsPrivate', flag);
                }
            }
            return flag;
        },

        async loadCities({ commit }, search = null) {
            if (!search) {
                commit('setCities', []);
                return [];
            }

            const fiasLevels = ['1', '4', '5', '6', '65'];
            let response = await post('dadata', 'search', `query=${search}&type=address`, true, {
                'content-type': 'application/x-www-form-urlencoded',
            });

            let result =
                response && response.suggestions && response.suggestions.length
                    ? response.suggestions.filter(
                          (item) => fiasLevels.indexOf(item.data.fias_level) > -1 && item.data.city
                      )
                    : [];
            commit('setCities', result);
            return result;
        },

        clearSearchFilters({ commit }) {
            commit('setSearchFilters', []);
        },

        mergeSearchFilters({ getters, commit }, newFilters) {
            const initialFiltersWithoutNewFilters = getters.getSearchFilters.filter(
                (initialFilter) => !newFilters.find((newFilter) => initialFilter.name === newFilter.name)
            );
            const initialFiltersWithReplacedNewFilters = initialFiltersWithoutNewFilters.concat(newFilters);
            commit('setSearchFilters', initialFiltersWithReplacedNewFilters);
        },

        changeUserSearchLoading({ commit }, flag) {
            commit('setUserSearchLoading', flag);
        },

        async loadUserCareers({ commit }, userId) {
            let careers = [];

            try {
                const answer = await get('profile', `career/${userId}`, {}, true, false);
                careers = answer && answer.data && answer.data.career ? answer.data.career : [];
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserCareers', careers);
            }
        },

        async loadUserEducations({ commit }, userId) {
            let careers = [];

            try {
                const answer = await get('profile', `education/${userId}`, {}, true, false);
                careers = answer && answer.data && answer.data.education ? answer.data.education : [];
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserEducations', careers);
            }
        },

        async loadUserCourses(ctx, { userId, payload }) {
            const query = [];

            if (payload.limit !== undefined) {
                query.push(`limit=${payload.limit}`);
            }

            if (payload.offset !== undefined) {
                query.push(`offset=${payload.offset}`);
            }

            if (payload.sort) {
                let i = 0;
                for (const field in payload.sort) {
                    query.push(`sort[${i}][column]=${field}`);
                    query.push(`sort[${i}][order]=${payload.sort[field]}`);
                    i++;
                }
            }

            if (payload.filters) {
                for (const field in payload.filters) {
                    const value = payload.filters[field];

                    if (value instanceof Array) {
                        value.forEach((v) => query.push(`filter[${field}][]=${encodeURIComponent(v)}`));
                    } else if (value instanceof Object) {
                        for (const subField in value) {
                            query.push(`filter[${field}][${subField}]=${encodeURIComponent(v)}`);
                        }
                    } else if (value !== null && value !== undefined && value !== '') {
                        query.push(`filter[${field}]=${encodeURIComponent(value)}`);
                    }
                }
            }

            try {
                const response = await get(
                    'event',
                    `event/track/participant/${userId}?${query.join('&')}`,
                    {},
                    true,
                    false
                );
                return response && response.data && response.data.events ? response.data.events : [];
            } catch (e) {
                console.error(e);
                return [];
            }
        },

        async loadUserComments({ commit }, userId) {
            let comments = [];

            try {
                const answer = await get('profile', `comments/${userId}`, {}, true, false);
                comments = answer && answer.data ? answer.data : [];
            } catch (e) {
                console.log(e);
            } finally {
                commit('setUserComments', comments);
            }
        },

        async createUserComment(ctx, { userId, text }) {
            await post('profile', `comment/create`, { userId: userId.toString(), body: text }, true);
        },
        async updateUserComment(ctx, { id, text }) {
            await post('profile', `comment/${id}/update`, { body: text }, true);
        },
        async removeUserComment(ctx, id) {
            await post('profile', `comment/${id}/remove`);
        },

        async updateUserTags(ctx, { userId, foreignTagsId }) {
            await post(
                'profile',
                'user/update',
                {
                    user_id: userId,
                    foreignTagsId,
                },
                true
            );
        },

        async loadChangeLogHistory(ctx, { userId, fields = null }) {
            const query = [];

            if (fields && fields instanceof Array) {
                for (const n in fields) {
                    query.push(`filter[fields][${n}]=${encodeURIComponent(fields[n])}`);
                }
            }

            return await get('profile', `user/${userId}/changeLog/findAll?${query.join('&')}`, {});
        },
    },

    getters: {
        getSearchingUsers: (state) => state.searchingUsers,
        getSearchingUsersPages: (state) => state.searchingUsersPages,
        getFilters: (state) => state.filters,
        showFilterField: (state) => (field) => {
            if (Array.isArray(field)) {
                return field.some((el) => state.filters && state.filters[el] && !state.filters[el].isHidden);
            }
            return state.filters && state.filters[field] && !state.filters[field].isHidden;
        },
        getCanDownload: (state) => {
            return Object.keys(state.loaded).filter((key) => state.loaded[key] === false).length === 0;
        },
        getUser: (state) => state.user,
        getUserAwards: (state) => state.userAwards,
        getUserProjects: (state) => state.userProjects,
        getUserProjectsSPK: (state) => state.userProjectsSPK,
        getLoaded: (state) => state.loaded,
        getUserCompetences: (state) => state.userCompetences,
        getUserProfessions: (state) => state.userProfessions,
        getUserFriends: (state) => state.userFriends,
        getUserFriendsTotal: (state) => state.userFriendsTotal,
        getUserIsAFriend: (state) => state.userIsAFriend,
        getUserHiddenFieldsProjects: (state) => state.userHiddenFieldsProjects,
        getUserHiddenFieldsProgress: (state) => state.userHiddenFieldsProgress,
        getUserChatIsPrivate: (state) => state.userChatIsPrivate,
        getChatWithUserIsPrivate: (state) => state.chatWithUserIsPrivate,
        getCities: (state) => state.cities,
        getSearchFilters: (state) => state.searchFilters,
        getUserSearchLoading: (state) => state.userSearchLoading,
        getUserCareers: (state) => state.userCareers,
        getUserEducations: (state) => state.userEducations,
        getUserComments: (state) => state.userComments,
        getKeySkills: (state, getters, rootState, rootGetters) => {
            return (state.user.keySkills || [])
                .map((skill) => {
                    if (skill.rsvDataId) {
                        return rootGetters['data/getRegistryValueById'](skill.rsvDataId);
                    }
                    return skill.title;
                })
                .filter((s) => s);
        },
        getInterests: (state, getters, rootState, rootGetters) => {
            return (state.user.interests || []).map((interest) => {
                if (interest.rsvDataId) {
                    return rootGetters['data/getRegistryValueById'](interest.rsvDataId);
                }
                return interest.title;
            });
        },
        getSocials: (state, getters, rootState, rootGetters) => {
            if (!rootGetters['auth/hasUserContactsAccess']) {
                return [];
            }

            const contacts = [];

            const phone = state.user.tel || state.user.regTel;

            if (phone) {
                contacts.push({
                    icon: 'phone',
                    value: phone,
                    link: '',
                });
            }

            const email = state.user.email || state.user.regEmail;

            if (email) {
                contacts.push({
                    icon: 'email',
                    value: email,
                    link: '',
                });
            }

            const socials = [
                { icon: 'telegram', prop: 'telegram' },
                { icon: 'vk', prop: 'vk' },
                { icon: 'ok', prop: 'ok' },
                { icon: 'zen', prop: 'zen' },
                { icon: 'yt', prop: 'yt' },
                { icon: 'rutube', prop: 'rutube' },
                { icon: 'tiktok', prop: 'tiktok' },
                { icon: 'yappy', prop: 'yappy' },
                { icon: 'tenchat', prop: 'tenchat' },
            ];

            return [
                ...contacts,
                ...socials
                    .filter((item) => state.user[item.prop])
                    .map((item) => {
                        return {
                            icon: item.icon,
                            value: state.user[item.prop],
                            link: state.user[item.prop],
                        };
                    }),
            ];
        },
        getUserLanguages: (state, getters, rootState, rootGetters) => {
            return (state.user.userLanguages || []).map((lang) => {
                return {
                    title: rootGetters['data/getRegistryValueById'](lang.foreignLanguageId),
                    level: rootGetters['data/getRegistryValueById'](lang.foreignLanguageLevelId),
                };
            });
        },
        getAllUserProjects: (state) => {
            function parseProjectDate(date) {
                if (!date) {
                    return null;
                }

                const arr = date.toString().split(/^(\d{4})(\d{2})(\d{2})$/);

                return arr.length === 5 ? `${arr[1]}-${arr[2]}-${arr[3]}` : null;
            }

            return [
                ...state.userProjectsSPK.map((v) => {
                    v._source = 'spk';
                    return v;
                }),
                ...state.userProjects
                    .filter(
                        (v) =>
                            ['contests', 'contest', 'centres_of_competitions', 'project', 'internship'].indexOf(
                                v.project_type
                            ) !== -1
                    )
                    .map((v) => {
                        v._source = 'projects';
                        v.dateStart = parseProjectDate(v.date_start);
                        v.dateEnd = parseProjectDate(v.date_end);
                        return v;
                    }),
            ].sort((a, b) => {
                if ((!a.dateStart || !b.dateStart) && !(!a.dateStart && !b.dateStart)) {
                    return a.dateStart ? -1 : 1;
                }

                const startDiff = moment(a.dateStart || new Date()).diff(b.dateStart || new Date());

                if (startDiff !== 0) {
                    return startDiff > 0 ? -1 : 1;
                }

                if (!a.dateEnd || !b.dateEnd) {
                    return !a.dateEnd && !b.dateEnd ? 0 : a.dateEnd ? -1 : 1;
                }

                const endDiff = moment(a.dateEnd || new Date()).diff(b.dateEnd || new Date());

                return endDiff === 0 ? 0 : endDiff > 0 ? -1 : 1;
            });
        },
        getExperience(state) {
            const strCounterYears = str_counter('', 'год', 'года', 'лет');
            const strCounterMonths = str_counter('месяц', '', 'а', 'ев');

            const expDays = state.user.workExperience;

            if (!expDays || state.isNoWorkExperience) {
                return 'Нет данных';
            }

            const monthAverage = 30.4375;
            const years = Math.floor(expDays / (monthAverage * 12));
            const months = Math.floor((expDays - years * 12 * monthAverage) / monthAverage);

            const data = [
                years ? `${years} ${strCounterYears(years)}` : null,
                months ? `${months} ${strCounterMonths(months)}` : null,
            ];

            return data.filter((v) => v).join(' ');
        },
        getDownloadData(state, getters, rootState, rootGetters) {
            function age(dateOfBirth) {
                if (!dateOfBirth) {
                    return 'Нет данных';
                }

                const age = differenceInYears(new Date(), parseISO(dateOfBirth));
                const postfix = str_counter('', 'год', 'года', 'лет')(age);

                return `${age} ${postfix}`;
            }

            const formatter = Intl.NumberFormat('ru', {
                maximumFractionDigits: 0,
            });
            let status = state.user.foreignJobStatusId;
            let jobStatus = 'Нет данных';
            if (status) {
                jobStatus = rootGetters['data/getRegistryValueById'](status);
            }
            status = state.user.foreignMaritalStatusId;
            let maritalStatus = [];

            if (status) {
                maritalStatus.push(rootGetters['data/getRegistryValueById'](status));
            } else {
                maritalStatus.push('неизвестно');
            }
            if (state.user.children) {
                maritalStatus.push('дети: ' + state.user.children);
            } else if (state.user.children === 0) {
                maritalStatus.push('дети: нет');
            } else {
                maritalStatus.push('дети: нет данных');
            }

            maritalStatus = maritalStatus.join(', ');
            maritalStatus = maritalStatus.charAt(0).toUpperCase() + maritalStatus.substring(1);
            const allEducation = state.userEducations
                .sort((a, b) => {
                    if ((a.isNow || b.isNow) && !(a.isNow && b.isNow)) {
                        return a.isNow ? -1 : 1;
                    }

                    if ((!a.dateStart || !b.dateStart) && !(!a.dateStart && !b.dateStart)) {
                        return a.dateStart ? -1 : 1;
                    }

                    const startDiff = moment(a.dateStart || new Date()).diff(b.dateStart || new Date());

                    if (startDiff !== 0) {
                        return startDiff > 0 ? -1 : 1;
                    }

                    if (!a.dateEnd || !b.dateEnd) {
                        return !a.dateEnd && !b.dateEnd ? 0 : a.dateEnd ? -1 : 1;
                    }

                    const endDiff = moment(a.dateEnd || new Date()).diff(b.dateEnd || new Date());

                    return endDiff === 0 ? 0 : endDiff > 0 ? -1 : 1;
                })
                .map((education) => {
                    let level = rootGetters['data/getRegistryItems']('education_level').find(
                        (v) => v.id === education.foreignLevelId
                    );
                    let name = education.educationPlace;
                    if (education.foreignPlaceId) {
                        name = rootGetters['data/getRegistryValueById'](education.foreignPlaceId);
                    }
                    const levelName = level ? level.field_name : '';
                    level = level ? level.field_value : '';
                    let from = education.dateStart ? moment(education.dateStart).format('MMMM YYYY') : 'нет данных';
                    let till = education.dateEnd
                        ? moment(education.dateEnd).format('MMMM YYYY')
                        : education.isNow
                        ? 'по настоящее время'
                        : 'нет данных';
                    if (!education.isNow && !education.dateStart && !education.dateEnd) {
                        from = 'Период не указан';
                        till = '';
                    }

                    return {
                        year: education.dateEnd ? moment(education.dateEnd).format('YYYY') : 'Не указан',
                        from: from.charAt(0).toUpperCase() + from.substring(1),
                        till: till.charAt(0).toUpperCase() + till.substring(1),
                        level,
                        levelName,
                        name,
                        faculty: education.faculty || '',
                    };
                });

            const additionalEducation = allEducation.filter((row) => {
                return ['add', 'profi'].includes(row.levelName);
            });

            const education = allEducation.filter((row) => {
                return [
                    'hi_master',
                    'hi_specialist',
                    'foreign',
                    'middle_profi',
                    'hi_bachelor',
                    'hi_prof_cadr',
                ].includes(row.levelName);
            });

            const priority = {
                Победитель: 1,
                Финалист: 2,
                Полуфиналист: 3,
            };
            const additionalInformation = [];
            if (state.user.socialLiftType) {
                const value = rootGetters['data/getRegistryValueById'](state.user.socialLiftType);
                additionalInformation.push({
                    name: 'Социальный лифт',
                    value,
                });
            }

            if (state.user.isSocial && state.user.socialActivity) {
                additionalInformation.push({
                    name: 'Социальная активность',
                    value: state.user.socialActivity,
                });
            }

            if (state.user.isVolunteer && state.user.volunteerActivity) {
                const value = rootGetters['data/getRegistryValueById'](state.user.socialLiftType);
                additionalInformation.push({
                    name: 'Волонтерская деятельность',
                    value: state.user.volunteerActivity,
                });
            }

            const hasContactsAccess = rootGetters['auth/hasUserContactsAccess'];

            let avatar = `https://${window.rsvDomain}${require('@/assets/images/account/placeHolder-m.png')}`;
            if (state.user.avatar) {
                avatar = state.user.avatar.url;
            }
            if (state.user.avatarOfficial) {
                avatar = state.user.avatarOfficial.url;
            }

            return {
                userId: state.user.userId,
                image: avatar,
                fio: [state.user.surname || '', state.user.name || '', state.user.patronymic || '']
                    .filter((s) => s)
                    .join(' '),
                dateOfBirth: state.user.dateOfBirth
                    ? moment(state.user.dateOfBirth).format('DD MMMM YYYY') + ' года'
                    : 'Не указана',
                age: age(state.user.dateOfBirth),
                email: hasContactsAccess ? state.user.email || '' : '-',
                phone: hasContactsAccess ? state.user.tel || '' : '-',
                maritalStatus,
                jobStatus,
                experience: state.user.isNoWorkExperience ? 'Нет опыта работы' : getters.getExperience,
                isGovernmentWorker: !state.user.isNoWorkExperience && !!state.user.isGovernmentWorker,
                about: state.user.about || '-',
                achievements: state.userAchievements.map((achievement) => achievement.testName),
                achievementsArr: state.userAchievements.map((achievement) => {
                    return {
                        title: achievement.testName,
                        date: moment(achievement.createdAt).format('DD.MM.YYYY'),
                    };
                }),
                achievementsEmpty: state.userAchievements.length === 0 ? 'Нет данных' : '',
                activity: (
                    state.user.activity.map((activity) => {
                        return rootGetters['data/getRegistryValueById'](activity);
                    }) || []
                ).join(', '),
                salary: state.user.salaryLevel ? formatter.format(state.user.salaryLevel) + ' р.' : 'Нет данных',
                address: state.user.address ? state.user.address.value : '',
                citizenship: state.user && state.user.citizenship ? state.user.citizenship.value : '',
                keySkills: getters.getKeySkills.join(', ') || 'Нет данных',
                keySkillsArr: getters.getKeySkills,
                interests: getters.getInterests,
                languages: getters.getUserLanguages,
                projects: getters.getAllUserProjects.map((project) => {
                    const participantStatus = project.nominations.reduce((result, nomination) => {
                        const status = rootGetters['data/getRegistryValueById'](nomination.participantStatus);
                        if (result === '') {
                            if (Object.keys(priority).includes(status)) {
                                result = status;
                            }
                        } else if (Object.keys(priority).includes(status)) {
                            if (priority[status] < priority[result]) {
                                result = status;
                            }
                        }
                        return result;
                    }, '');
                    return [project.name, participantStatus].filter((s) => s).join(', ');
                }),
                projectsEmpty: getters.getAllUserProjects.length === 0 ? 'Нет данных' : '',
                projectsArr: getters.getAllUserProjects.map((project) => {
                    const ret = {
                        name: '',
                        logo: '',
                        nominations: [],
                    };
                    if (project._source === 'spk') {
                        ret.name = project.name;
                        ret.logo =
                            project.logo ||
                            `https://${window.rsvDomain}${require('@/assets/images/portfolio/no-image.svg')}`;
                        ret.nominations = project.nominations.map((nomination) => {
                            nomination.period = [
                                nomination.dateStart ? moment(nomination.dateStart).format('DD.MM.YYYY') : null,
                                nomination.dateEnd ? moment(nomination.dateEnd).format('DD.MM.YYYY') : null,
                            ]
                                .filter((v) => v)
                                .join(' – ');
                            let participantStatus = rootGetters['data/getRegistryItems']('stage_history').find(
                                (v) => v.id === nomination.participantStatus
                            );
                            participantStatus = participantStatus ? participantStatus.field_name : 'default';
                            nomination.participantStatus = rootGetters['data/getRegistryValueById'](
                                nomination.participantStatus
                            );
                            nomination.participantColor = '#4663AB';
                            if (['default', 'party'].includes(participantStatus)) {
                                nomination.participantColor = '#68C87A';
                            } else if (['final'].includes(participantStatus)) {
                                nomination.participantColor = '#69609F';
                            } else if (['half'].includes(participantStatus)) {
                                nomination.participantColor = '#A0C8EA';
                            }
                            return nomination;
                        });
                    } else {
                        ret.name = project.name;
                        ret.logo =
                            project.image_link ||
                            `https://${window.rsvDomain}${require('@/assets/images/portfolio/no-image.svg')}`;
                        ret.nominations = project.nominations.map((nomination) => {
                            nomination.period = [
                                project.dateStart ? moment(project.dateStart).format('DD.MM.YYYY') : null,
                                project.dateEnd ? moment(project.dateEnd).format('DD.MM.YYYY') : null,
                            ]
                                .filter((v) => v)
                                .join(' – ');
                            let participantStatus = rootGetters['data/getRegistryItems']('stage_history').find(
                                (v) => v.id === nomination.participantStatus
                            );
                            participantStatus = participantStatus ? participantStatus.field_name : 'default';
                            nomination.participantStatus = rootGetters['data/getRegistryValueById'](
                                nomination.participantStatus
                            );
                            nomination.participantColor = '#4663AB';
                            if (['default', 'party'].includes(participantStatus)) {
                                nomination.participantColor = '#68C87A';
                            } else if (['final'].includes(participantStatus)) {
                                nomination.participantColor = '#69609F';
                            } else if (['half'].includes(participantStatus)) {
                                nomination.participantColor = '#A0C8EA';
                            }
                            return nomination;
                        });
                    }
                    return ret;
                }),
                eventsArr: state.userEvents.map((event) => {
                    return {
                        title: event.name,
                        period: [
                            event.dateStart ? moment(event.dateStart).format('DD.MM.YYYY') : null,
                            event.dateEnd ? moment(event.dateEnd).format('DD.MM.YYYY') : null,
                        ]
                            .filter((v) => v)
                            .join(' – '),
                    };
                }),
                coursesArr: state.userCourses.map((course) => {
                    return {
                        title: course.name,
                        date: course.participant ? moment(course.participant.statusUpdatedAt).format('DD.MM.YYYY') : '',
                    };
                }),
                internshipsArr: state.userInternShipsSPK.map((internship) => {
                    let color = '#D4EAFE';
                    let participantStatus = rootGetters['data/getRegistryItems']('stage_history').find(
                        (v) => v.id === internship.nominations[0].participantStatus
                    );
                    participantStatus = participantStatus ? participantStatus.field_name : 'default';
                    if (['default', 'party'].includes(participantStatus)) {
                        color = '#68C87A';
                    } else if (['final'].includes(participantStatus)) {
                        color = '#E1DFEC';
                    } else if (['half'].includes(participantStatus)) {
                        color = '#A0C8EA';
                    } else if (['intern'].includes(participantStatus)) {
                        color = '#68C87A';
                    }
                    return {
                        name: internship.name,
                        logo:
                            internship.logo ||
                            `https://${window.rsvDomain}${require('@/assets/images/portfolio/no-image.svg')}`,
                        participantStatus: rootGetters['data/getRegistryValueById'](
                            internship.nominations[0].participantStatus
                        ),
                        participantColor: color,
                    };
                }),
                vacanciesArr: state.userVacanciesSPK.map((vacancy) => {
                    return {
                        name: vacancy.name,
                    };
                }),
                career: state.userCareers
                    .sort((a, b) => {
                        if ((a.isUntilNow || b.isUntilNow) && !(a.isUntilNow && b.isUntilNow)) {
                            return a.isUntilNow ? -1 : 1;
                        }

                        if ((!a.dateStart || !b.dateStart) && !(!a.dateStart && !b.dateStart)) {
                            return a.dateStart ? -1 : 1;
                        }

                        const startDiff = moment(a.dateStart || new Date()).diff(b.dateStart || new Date());

                        if (startDiff !== 0) {
                            return startDiff > 0 ? -1 : 1;
                        }

                        if (!a.dateEnd || !b.dateEnd) {
                            return !a.dateEnd && !b.dateEnd ? 0 : a.dateEnd ? -1 : 1;
                        }

                        const endDiff = moment(a.dateEnd || new Date()).diff(b.dateEnd || new Date());

                        return endDiff === 0 ? 0 : endDiff > 0 ? -1 : 1;
                    })
                    .map((career) => {
                        let from = career.dateStart ? moment(career.dateStart).format('MMMM YYYY') : 'нет данных';
                        let till = career.dateEnd
                            ? moment(career.dateEnd).format('MMMM YYYY')
                            : career.isUntilNow
                            ? 'по настоящее время'
                            : 'нет данных';
                        if (!career.isUntilNow && !career.dateStart && !career.dateEnd) {
                            from = 'Период не указан';
                            till = '';
                        }
                        const period = [from, till].filter((s) => s).join(' - ');

                        return {
                            period: period.charAt(0).toUpperCase() + period.substring(1),
                            from: from.charAt(0).toUpperCase() + from.substring(1),
                            till: till.charAt(0).toUpperCase() + till.substring(1),
                            organisation: career.organisation || '',
                            position: career.position || '',
                            responsibilities: career.responsibilities || '',
                        };
                    }),
                careerEmpty: state.userCareers.length === 0 ? 'Нет данных' : '',
                allEducation,
                education,
                educationEmpty: education.length === 0 ? 'Нет данных' : '',
                additionalEducation: additionalEducation,
                additionalEducationEmpty: additionalEducation.length === 0 ? 'Нет данных' : '',
                competences: state.userCompetences
                    .filter((v) => v.type === 'soft' && v.competenceLevel)
                    .map((v) => {
                        switch (v.competenceLevel) {
                            case 'basic':
                                v.levelId = 1;
                                v.levelName = 'базовый';
                                break;
                            case 'intermediate':
                                v.levelId = 2;
                                v.levelName = 'средний';
                                break;
                            case 'advanced':
                                v.levelId = 3;
                                v.levelName = 'продвинутый';
                                break;
                        }
                        return v;
                    })
                    .filter((v) => v.levelId),
                additionalInformation,
                socials: hasContactsAccess ? getters.getSocials : [],
            };
        },
    },
};
